import { render, staticRenderFns } from "./new-plate.vue?vue&type=template&id=d55c5670&scoped=true&"
import script from "./new-plate.vue?vue&type=script&lang=js&"
export * from "./new-plate.vue?vue&type=script&lang=js&"
import style0 from "./new-plate.vue?vue&type=style&index=0&id=d55c5670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55c5670",
  null
  
)

export default component.exports